<template>
  <project-template title="完成方案配置" nextBtnText="下一步：确认启动" @lastClick="lastClick" @nextClick="nextClick">
    <template v-slot:leftContent>
      <ul class="list">
        <li v-for="(item, index) in menu" :class="[cur === index && 'cur']">
          <strong>{{ item }}</strong>
          <a href="javascript:;" @click="itemClick(index)">
            <span>查看</span>
            <arrow-to-right></arrow-to-right>
          </a>
        </li>
      </ul>
    </template>
    <template v-slot:rightContent>
      <div class="resource" v-if="cur === 0">
        <div>
          <h3>一、项目概述</h3>
          <a-row>
            <a-col :span="24">
              项目预计开始时间：{{ project.startDate }}
            </a-col>
            <a-col :span="24">
              项目实施中心：{{ project.centerNames }}
            </a-col>
            <!-- <a-col :span="12">
              是否开启预实验：{{ config.beforeTest === 1 ? '是' : '否' }}
            </a-col> -->
            <a-col :span="12">
              是否开启多病种：{{ config.manyType === 1 ? '是' : '否' }}
            </a-col>
            <a-col :span="12">
              项目负责人：{{ project.contactName }}
            </a-col>
            <a-col :span="12">
              联系电话：{{ project.contactPhone }}
            </a-col>
            <a-col :span="24">
              项目简介：{{ project.intro }}
            </a-col>
          </a-row>
        </div>

        <div>
          <h3>二、方案配置</h3>
          <a-row>
            <a-col :span="24" v-for="list in JSON.parse(config.deptJson ? project.deptJson : '[]')" :key="list.id">
              1. 研究科室： {{ list.name }}
            </a-col>
            <!-- <a-col :span="24" v-for="list in JSON.parse(config.diseaseJson ? project.diseaseJson : '[]')"
              :key="list.id">
              2. 研究病种： {{ list.name }}
            </a-col> -->
            <a-col :span="24">
              2. 研究病种：{{ selectDisease }}
            </a-col>
            <a-col :span="24">
              3. 研究模块：{{ selectModule }}
            </a-col>

            <a-col :span="24">
              3. 量表配置： {{ selectForm }}
            </a-col>
            <a-col :span="24">
              4. 周期节点：

              <div v-for="(form, index) in selectPerid" :key="index">
                {{ form }}
              </div>
            </a-col>
            <a-col :span="24">
              5. 项目执行时间：{{ project.startDate }} 至{{ project.planEndDate }}
            </a-col>
            <a-col :span="24">
              <h3>三、纳排标准</h3>
              <b>纳入条件:</b>
              <div v-for="(form, index) in filtrateOne" :key="index">
                {{ form }}
              </div>
             <br>
              <b>排除条件：</b>
              <div v-for="(form, index) in filtrateTwo" :key="index">
                {{ form }}
              </div>
            </a-col>
            <a-col :span="24">
              <h3>四、投入成本</h3>
              <a-row>
                <a-col :span="12">
                  人力投入：{{ config.costInfo.dataUserCount + config.costInfo.otherUserCount }}人
                </a-col>
                <a-col :span="12">
                  人力成本：{{ config.costInfo.personCost }}元
                </a-col>
                <a-col :span="24">
                  耗材投入：
                </a-col>
                <a-col :span="24">
                  <a-table :columns="columns" :data-source="materialList" :row-key="record => record.project"
                    :pagination="false"></a-table>
                </a-col>
              </a-row>
            </a-col>

          </a-row>
        </div>
      </div>

      <!-- <img v-if="cur === 1" :src="require('@/assets/ethics.png')" alt=""> -->
      <!-- <img v-if="cur === 2" :src="require('@/assets/testament.png')" alt=""> -->
      <FlowChartOne v-if="cur === 1" />
      <FlowChartTwo v-if="cur === 2" />
    </template>
  </project-template>
</template>

<script>
import FlowChartOne from '@views/apppad/projectTemplate/FlowChartOne'
import FlowChartTwo from '@views/apppad/projectTemplate/FlowChartTwo'
import ArrowToRight from '@comp/Icon/ArrowToRight'
import IconBack from '@comp/Icon/IconBack';
import { getAction } from '@api/manage'

import ProjectTemplate from '@comp/pad/ProjectTemplate'

export default {
  name: 'ProjectTemplate6',
  components: { FlowChartOne, FlowChartTwo, ArrowToRight, ProjectTemplate, IconBack },
  data() {
    return {
      project: {},
      period: [],
      filtrate: [],
      filtrateOne: [],
      filtrateTwo: [],
      config: {costInfo:{dataUserCount:0,otherUserCount:0,personCost:0}},
      cur: 0,
      selectDisease: '',
      selectModule: '',
      selectForm: '',
      selectPerid: [],
      menu: ['项目方案预览', '伦理准备', '人遗准备'],
      columns: [
        {
          title: '项目',
          dataIndex: 'name',
          width: '33%',
        },
        {
          title: '数量',
          dataIndex: 'num',
          width: '33%',
        },
        {
          title: '成本',
          dataIndex: 'totalPrice',
          width: '33%',
        },
      ],
      materialList: [],
      // data: [
      //   {
      //     project: '采血',
      //     num: 2,
      //     cost: 1000
      //   },
      //   {
      //     project: '粪便',
      //     num: 2,
      //     cost: 1000
      //   },
      // ],
    }
  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryAllInfoById', { id: id }).then(res => {
        if (res.success) {
          this.project = res.result.project
          this.period = res.result.period
          this.filtrate = res.result.filtrate
          this.config = res.result.config
          this.materialList = res.result.material
          this.getModuleAndForm()
          this.getPeriod()
          this.getfiltrate()
          this.getDiseaseList()
        }
      })
    },
    getDiseaseList() {
      const diseaseList = JSON.parse(this.config.diseaseJson)
      diseaseList.forEach(item => {
        this.selectDisease += item.name + "/"
      })
    },

    getModuleAndForm() {
      const moduleData = JSON.parse(this.config.moduleJson)
      for (let key in moduleData) {
        if (moduleData[key]) {
          moduleData[key].map(item => {
            this.selectModule += item.name + "/"
            if (item.checkedFormList) {
              item.checkedFormList.forEach(form => {
                this.selectForm += form.name + "/"
              })
            }
          })
        }
      }
    },
    getPeriod() {
      this.period.forEach(item => {
        let periodInfo = item.name + "  :  "
        if (item.formList) {
          item.formList.forEach(form => {
            periodInfo += form.formName + "/"
          })
        }
        this.selectPerid.push(periodInfo)
      })
    },
    getfiltrate() {
      this.filtrate.forEach(item => {
        if (item.type === "1") {
          this.filtrateOne.push(item.sortNum + "." + item.description)
        } else {
          this.filtrateTwo.push(item.sortNum + "." + item.description)
        }
      })
    },

    itemClick(key) {
      this.cur = key;
    },
    nextClick() {
      this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    },
  }
}
</script>

<style scoped lang="less">
.list {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 17px 10px;
    margin-bottom: 24px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);

    a {
      display: inline-flex;
      color: white;

      span {
        margin-right: 5px;
      }
    }
  }

  .cur {
    background-color: rgba(55, 110, 255, 1);
  }
}

.resource {
  color: white;

  h3 {
    color: white;
  }

  /deep/ .ant-col {
    padding: 10px 0;
  }

  /deep/ .ant-table {
    color: white;
  }

  /deep/ .ant-table-body {
    min-width: unset !important;
  }
}
</style>